export default __webpack_public_path__ + "static/media/filter_list.60f26af3.svg";